import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, EmptyState, StatusBadge } from "@/components/common";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { GitPullRequest } from "lucide-react";

export default function ChangeRequests({ crossOrg = false }) {
  const navigate = useNavigate();
  const { actingOrgId } = useAuth();
  const { data: crs = [], isLoading } = useQuery({
    queryKey: ["change-requests", crossOrg, actingOrgId],
    queryFn: async () => (await api.get(crossOrg ? "/admin/change-requests" : "/org/change-requests")).data,
  });

  return (
    <div>
      <PageHeader title="Change Requests" description={crossOrg ? "All organisations" : "Requests from your employees"} />
      {isLoading ? <p className="text-sm text-slate-500">Loading…</p> : crs.length === 0 ? (
        <EmptyState title="No change requests" hint="Employee change requests appear here" icon={GitPullRequest} />
      ) : (
        <Card className="divide-y divide-slate-100">
          {crs.map((cr) => (
            <div key={cr.id} className="flex items-center justify-between px-5 py-3" data-testid={`cr-row-${cr.id}`}>
              <div>
                <p className="text-sm font-medium text-slate-800">{cr.employee_name} <span className="text-xs text-slate-400">{cr.employee_email}</span></p>
                <p className="text-xs text-slate-500">Sections: {(cr.sections || []).join(", ")} · {cr.reason}{crossOrg && cr.org_name ? ` · ${cr.org_name}` : ""}</p>
              </div>
              <div className="flex items-center gap-3">
                <StatusBadge status={cr.status} />
                {!crossOrg && (
                  <Button size="sm" variant="outline" onClick={() => navigate(`/org/employees/${cr.employee_id}`)} data-testid={`open-emp-${cr.id}`}>Open</Button>
                )}
              </div>
            </div>
          ))}
        </Card>
      )}
    </div>
  );
}
